<template functional>
    <div class="user-avatar" :class="[data.class, data.staticClass, props.size]">
        <img :src="props.avatar !== '' ? props.avatar : '/img/avatar.png'" onerror="this.src='/img/avatar.png'">
    </div>
</template>

<script>
    export default {
        name: 'UserAvatar',

        props: {
            avatar: {
                required: true,
                default: '',
            },

            size: {
                default: '',
            },
        },
    };
</script>

<style lang="scss" scoped>
    .user-avatar {
        @apply tw-rounded-full tw-overflow-hidden;
        width: 30px;
        height: 30px;
        flex-basis: 30px;
        min-width: 30px;

        img {
            width: 30px;
            height: 30px;
            flex-basis: 30px;
            object-fit: cover;
        }

        &.lg {
            width: 40px;
            height: 40px;
            flex-basis: 40px;
            min-width: 40px;

            img {
                width: 40px;
                height: 40px;
                flex-basis: 40px;
            }
        }
    }
</style>
